module.exports = __webpack_public_path__ + "static/scale-model-of-bakersfield-museum-of-art-in-bakersfield-california-1ccbe492d30ad4dfc2233166ad10896e.png";